import { LabelAlign } from "@certn/cascadia-react/components/types";
import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  NumberField as AriaNumberField,
  NumberFieldProps,
} from "react-aria-components";

import { sharedStyles } from "../utils";

interface Props extends NumberFieldProps {
  labelAlign?: LabelAlign;
}

export function NumberField(props: Props) {
  const { labelAlign = "vertical" } = props;
  const className = css(sharedStyles.field);

  return (
    <AriaNumberField
      {...mergeProps(props, { className })}
      data-label-orientation={labelAlign}
    />
  );
}
